<template>
  <section class="order-document-info-modal">
    <v-btn      
      icon
      color="warning"
      title="Informações do Documento"
      @click.prevent.stop="openModal()"
    >
      <v-icon size="15">
        info
      </v-icon>
    </v-btn>

    <OrderDocumentInfoModal
      v-if="modal.show"
      :order="order"
      :documentId="documentId"
      :documentIds="documentIds"
      :documentIndex="documentIndex"
      @close="closeModal"
    />
  </section>
</template>

<script>
  import OrderDocumentInfoModal from './OrderDocumentInfoModal.vue';
  import { mapActions } from 'vuex';

  export default {
    name: 'OrderDocumentInfoButton',
    
    components: {
      OrderDocumentInfoModal
    },

    props: {
      order: {
        type: Object,
        required: true
      },
      
      documentId: {
        type: Number,
        required: true
      },

      documentIds: {
        type: Array,
        default: () => [],
      },

      documentIndex: {
        type: Number,
        default: 0,
      },
    },

    data: () => ({
      modal: {
        show: false
      },
    }),

    methods: {
      closeModal() {
        this.modal.show = false;
        this.fetchOrder(this.order.id);
        this.$emit('close');
      },

      openModal() {
        this.modal.show = true;        
      },

      ...mapActions('pedido', { 
        fetchOrder: 'SHOW'       
      }),
    },
  }
</script>